<template lang="pug">
    div
        item-form-group(v-if='formFilled' v-for='group in getSortedGroups' :key='group.id' :group='group')
        div(class='lg:grid lg:grid-cols-3 lg:gap-6')
            div(class='sm:px-6 lg:col-span-3 py-3 mt-4'
            +' px-4 text-center bg-gray-50')
                button(@click='saveForm' type='submit'
                    :disabled='isDisabled'
                    class='inline-flex justify-center py-2 px-4 border'
                    +' border-transparent shadow-sm text-sm font-medium'
                    +' rounded-md text-white bg-indigo-600 w-1/2 md:w-1/4'
                    +' lg:w-1/6 hover:bg-indigo-700 focus:outline-none'
                    +' focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                    +' disabled:opacity-75')
                    | Сохранить
</template>

<script>

import ItemFormGroup from 'cmp@/ItemFormGroup'
import store from 'js@/store'
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'

export default {

    name: 'ItemForm',

    store,

    components: {
        'item-form-group': ItemFormGroup,
    },

    props: {
        machineryType: {
            type: Number,
            required: true,
        },

        redirectUrl: {
            type: String,
            required: true,
        },

        resourceUrl: {
            type: String,
            required: true,
        },

        machineryItem: {
            type: Number,
            required: false,
        },

        formType: {
            type: String,
            default: 'create',
        },

        extra: {
            type: Object,
        }
    },

    data () {
        return {
            formFilled: false,
            isDisabled: false,
        }
    },

    computed: {
        ...mapGetters({
            getSortedGroups: 'item/getSortedGroups',
            isGroupsExist: 'item/isGroupsExist',
            checkErrors: 'item/checkErrors',
        }),

        ...mapState({
            isMobile: state => state.item.isMobile,
        }),
    },

    async mounted() {

        // set global state for watching window width
        this.checkWidth()
        window.addEventListener('resize', this.checkWidth)

        // for special extra parameters
        if (this.extra) {
            this.setGlobalExtra(this.extra)
        }
        await this.createForm()
        this.formFilled = true
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.checkWidth)
    },

    methods: {
        ...mapMutations({
            updateFormStatus: 'item/updateFormStatus',
            scrolling: 'item/scrolling',
            setScrolled: 'item/setScrolled',
            setResourceUrl: 'item/setResourceUrl',
            setGlobalExtra: 'item/setGlobalExtra',
            updateIsMobile: 'item/updateIsMobile',
            addError: 'item/addError',
        }),

        ...mapActions({
            getGroupsByType: 'item/getGroupsByType',
            getGroupsByItem: 'item/getGroupsByItem',
            fillData: 'item/fillData',
            updateItem: 'item/updateItem',
            createItem: 'item/createItem',
        }),

        sendingOrScrolling (callback) {
            this.$nextTick(async _ => {
                if (!this.checkErrors) {
                    await callback()
                        .then(_ => {
                            window.location.href = this.redirectUrl
                        })
                        .catch(err => {
                            const errors = err.response.data.errors
                            for (let error in errors) {
                                if (errors.hasOwnProperty(error)) {
                                    this.addError({
                                        id: error.replace('data.', ''),
                                        message: errors[error][0],
                                    })
                                }
                            }
                            setTimeout(() => {
                                this.isDisabled = false
                            }, 500)
                            this.scrolling()
                        })
                } else {
                    setTimeout(() => {
                        this.isDisabled = false
                    }, 500)
                    this.scrolling()
                }
            })
        },

        async saveForm () {
            this.isDisabled = true

            this.updateFormStatus(Symbol('checkForm'))
            this.setScrolled(false)
            if (this.formType === 'create') {

                this.sendingOrScrolling(async _ => {
                    await this.createItem({
                        typeId: this.machineryType,
                    })
                })

            } else if (this.formType === 'edit') {

                this.sendingOrScrolling(async _ => {
                    return await this.updateItem({
                        typeId: this.machineryType,
                        itemId: this.machineryItem,
                    })
                })

            }
        },

        async createForm() {
            this.setResourceUrl(this.resourceUrl)
            if (this.formType === 'edit') {
                await this.getGroupsByItem(this.machineryItem)
                await this.fillData(this.machineryItem)
            } else if (this.formType === 'create') {
                await this.getGroupsByType(this.machineryType)
            }
        },

        checkWidth() {
            if (window.innerWidth < 640 && !this.isMobile) {
                this.updateIsMobile(true)
            } else if (window.innerWidth > 639 && this.isMobile) {
                this.updateIsMobile(false)
            }
        },
    },
}

</script>
